import * as yup from 'yup'
// import messages from './messages.json'

export const portals = () => yup.object({

})
